export default "__VITE_ASSET__DB$GuVcD__"